<style scoped lang="scss">
.date-info {
	display: flex; flex-direction: row; align-items: center; justify-content: center;
	background-color: #3399ff;
	color: white;
	border-radius: 5px;
	padding: 5px 0;
	border-bottom: solid 1px #c9e1f0;
	.right {
		margin-left: 20px;
		cursor: pointer;
	}
}
.bb {
	border-bottom: solid 1px #c9e1f0;
}
.thr {
	background-color: #e8f6ff;
}
.th:hover {
	background-color: #E8E8E8!important;
}
.th {
	display: flex; flex-direction: row; align-items: center;
	
	border-bottom: solid 1px #c9e1f0;
	color: #336699;
	.week {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 120px;
		border-right: solid 1px #c9e1f0;
		border-left: solid 1px #c9e1f0;
	}
	.comp {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
	}
	.time {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
	}
	.vs {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 220px;
		border-right: solid 1px #c9e1f0;
	}
	.goal {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 100px;
		border-right: solid 1px #c9e1f0;
		.sub-goal {
			height: 40px;
			line-height: 40px;
			position: relative;
		}
		.single {
			position: absolute;
			top: 0;
			left: 0;
			font-size: 12px;
			width: 20px;
			height: 20px;
			line-height: 20px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			text-align: center;
			color: #ffffff;
			background-color: red;
		}
	}
	.h,.d,.a {
		height: 81px;
		line-height: 81px;
		width: 80px;
		text-align: center;
		border-right: solid 1px #c9e1f0;
		.bet-odds {
			height: 40px;
			line-height: 40px;
			cursor: pointer;
		}
		.active {
			background-color: orangered;
			color: white;
			.more-bet-name {
				font-weight: bold;
				color: #FFFFFF!important;
			}
			.more-bet-odds {
				color: #FFFFFF!important;
			}
		}
	}
	.more {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 80px;
		border-right: solid 1px #c9e1f0;
		color: #888888;
		cursor: pointer;
		position: relative;
		.selected {
			position: absolute;
			top: 0;
			right: 0;
			background-color: hotpink;
			color: white;
			width: 30px;
			height: 20px;
			line-height: 20px;
			border-bottom-left-radius: 20px;
			text-align: center;
		}
	}
	.result {
		height: 81px;
		line-height: 81px;
		text-align: center;
		width: 340px;
		border-right: solid 1px #c9e1f0;
		display: flex; flex-direction: row; align-items: center; flex-wrap: wrap;
		justify-content: center;
		.result-item {
			background-color: #3399ff; color: #ffffff;
			 border-radius: 5px;
			height: 20px;
			line-height: 20px;
			font-size: 12px;
			width: 40px;
			margin-right: 5px;
			margin-bottom: 5px;
		}
	}
}

.more-box {
	padding: 14px 10px 5px 10px;
	border-right: solid 1px #c9e1f0;
	border-left: solid 1px #c9e1f0;
	border-bottom: solid 1px #c9e1f0;
	background-color: #c9e1f0;
	.more-line {
		display: flex; flex-direction: row; align-items: flex-start;
		border-bottom: solid 1px #c9e1f0;
		.more-name {
			width: 120px;
			text-align: center;
			border: solid 1px #c9e1f0;
			margin-bottom: 10px;
			background-color: white;
		}
		.bqc {
			height: 41px;
			line-height: 41px;
		}
		.bf {
			height: 125px;
			line-height: 123px;
		}
		.more-bets {
			
			background-color: white;
			.more-line {
				.more-bet {
					cursor: pointer;
					height: 41px;
					width: 82px;
					border-right: solid 1px #c9e1f0;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.more-bet-name {
						font-weight: bold;
						color: #333333;
					}
					.more-bet-odds {
						color: #888888;
					}
				}
				.active {
					background-color: orangered;
					color: white;
					.more-bet-name {
						font-weight: bold;
						color: #FFFFFF!important;
					}
					.more-bet-odds {
						color: #FFFFFF!important;
					}
				}
			}
		}
	}
}
.green {
	color: orangered;
}
.blue {
	color: seagreen;
}
</style>
<template>
	<div style="border-bottom: solid 2px #c9e1f0;">
		<div class='th'>
			<div class='week'>{{match['issue_week']}}</div>
			<div class='comp'>
				<div :style="{'background': '#' + match.compColor}" style="color:white;">{{match['short_comp']}}</div>
			</div>
			<div class='time'>{{match['stop_time'].substr(11, 6)}}</div>
			<div class='vs'>{{match['short_home']}} VS {{match['short_away']}}</div>
			<div class='goal'>
				<div class='sub-goal bb'>
					{{ match['had'] && (match['had']['goal'] || '0') }}
					<div class='single' v-if="match['had']['single']">单</div>
				</div>
				<div class='sub-goal'>
					{{ match['hhad'] && (match['hhad']['goal'] || '-') }}
					<div class='single' v-if="match['hhad']['single']">单</div>
				</div>
			</div>
			<div class='h'>
				<div :class="['bet-odds','bb', {'active':selectedArr.includes(match.match_id + '@had@h')}]" @click="betClick(match, 'had', 'h')">
					{{ match['had'] && (match['had']['h'] || '-') }}
				</div>
				<div :class="['bet-odds', {'active':selectedArr.includes(match.match_id + '@hhad@h')}]" @click="betClick(match, 'hhad', 'h')">
					{{ match['hhad'] && (match['hhad']['h'] || '-') }}
				</div>
			</div>
			<div class='d'>
				<div :class="['bet-odds','bb', {'active':selectedArr.includes(match.match_id + '@had@d')}]" @click="betClick(match, 'had', 'd')">
					{{ match['had'] && (match['had']['d'] || '-') }}
				</div>
				<div :class="['bet-odds', {'active':selectedArr.includes(match.match_id + '@hhad@d')}]" @click="betClick(match, 'hhad', 'd')">
					{{ match['hhad'] && (match['hhad']['d'] || '-') }}
				</div>
			</div>
			<div class='a'>
				<div :class="['bet-odds','bb', {'active':selectedArr.includes(match.match_id + '@had@a')}]" @click="betClick(match, 'had', 'a')">
					{{ match['had'] && (match['had']['a'] || '-') }}
				</div>
				<div :class="['bet-odds', {'active':selectedArr.includes(match.match_id + '@hhad@a')}]" @click="betClick(match, 'hhad', 'a')">
					{{ match['hhad'] && (match['hhad']['a'] || '-') }}
				</div>
			</div>
			<div class='more' @click="moreFunc(match)">
				<span class='green' v-if="!match.isMore">展开</span>
				<span class='blue' v-if="match.isMore">闭合</span>
				<div class='selected' v-if="selectedArr.length > 0">{{selectedArr.length}}</div>
			</div>
			<div class='result'>
				<div class='result-item' v-if="match.result && match.result.spf && match.result.spf.length == 2">{{getResultName('had', match.result.spf[0])}}</div>
				<div class='result-item' v-if="match.result && match.result.rq && match.result.rq.length == 3">{{getResultName('hhad', match.result.rq[1])}}</div>
				<div class='result-item' v-if="match.result && match.result.jq && match.result.jq.length == 2">{{match.result.jq[0]}}球</div>
				<div class='result-item' v-if="match.result && match.result.bf && match.result.bf.length == 2">{{match.result.bf[0]}}</div>
				<div class='result-item' v-if="match.result && match.result.bqc && match.result.bqc.length == 3">{{getResultName('hafu', match.result.bqc[0] + '' + match.result.bqc[1])}}</div>
			</div>
		</div>
		<div class='more-box' v-if="match.isMore">
			<div class="more-line">
				<div class='more-name bqc'>半全场胜平负</div>
				<div class='more-bets'>
					<div class='more-line'>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@hh')}]" @click="betClick(match, 'hafu', 'hh')">
							<div class='more-bet-name'>胜胜</div>
							<div class='more-bet-odds'>{{match['hafu']['hh']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@hd')}]" @click="betClick(match, 'hafu', 'hd')">
							<div class='more-bet-name'>胜平</div>
							<div class='more-bet-odds'>{{match['hafu']['hd']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@ha')}]" @click="betClick(match, 'hafu', 'ha')">
							<div class='more-bet-name'>胜负</div>
							<div class='more-bet-odds'>{{match['hafu']['ha']}}</div>
						</div>
						
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@dh')}]" @click="betClick(match, 'hafu', 'dh')">
							<div class='more-bet-name'>平胜</div>
							<div class='more-bet-odds'>{{match['hafu']['dh']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@dd')}]" @click="betClick(match, 'hafu', 'dd')">
							<div class='more-bet-name'>平平</div>
							<div class='more-bet-odds'>{{match['hafu']['dd']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@da')}]" @click="betClick(match, 'hafu', 'da')">
							<div class='more-bet-name'>平负</div>
							<div class='more-bet-odds'>{{match['hafu']['da']}}</div>
						</div>
						
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@ah')}]" @click="betClick(match, 'hafu', 'ah')">
							<div class='more-bet-name'>负胜</div>
							<div class='more-bet-odds'>{{match['hafu']['ah']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@ad')}]" @click="betClick(match, 'hafu', 'ad')">
							<div class='more-bet-name'>负平</div>
							<div class='more-bet-odds'>{{match['hafu']['ad']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@hafu@aa')}]" @click="betClick(match, 'hafu', 'aa')">
							<div class='more-bet-name'>负负</div>
							<div class='more-bet-odds'>{{match['hafu']['aa']}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="more-line">
				<div class='more-name bqc'>总进球</div>
				<div class='more-bets'>
					<div class='more-line'>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s0')}]" @click="betClick(match, 'ttg', 's0')">
							<div class='more-bet-name'>0球</div>
							<div class='more-bet-odds'>{{match['ttg']['s0']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s1')}]" @click="betClick(match, 'ttg', 's1')">
							<div class='more-bet-name'>1球</div>
							<div class='more-bet-odds'>{{match['ttg']['s1']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s2')}]" @click="betClick(match, 'ttg', 's2')">
							<div class='more-bet-name'>2球</div>
							<div class='more-bet-odds'>{{match['ttg']['s2']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s3')}]" @click="betClick(match, 'ttg', 's3')">
							<div class='more-bet-name'>3球</div>
							<div class='more-bet-odds'>{{match['ttg']['s3']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s4')}]" @click="betClick(match, 'ttg', 's4')">
							<div class='more-bet-name'>4球</div>
							<div class='more-bet-odds'>{{match['ttg']['s4']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s5')}]" @click="betClick(match, 'ttg', 's5')">
							<div class='more-bet-name'>5球</div>
							<div class='more-bet-odds'>{{match['ttg']['s5']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s6')}]" @click="betClick(match, 'ttg', 's6')">
							<div class='more-bet-name'>6球</div>
							<div class='more-bet-odds'>{{match['ttg']['s6']}}</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@ttg@s7')}]" @click="betClick(match, 'ttg', 's7')">
							<div class='more-bet-name'>7+球</div>
							<div class='more-bet-odds'>{{match['ttg']['s7']}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="more-line">
				<div class='more-name bf'>比分</div>
				<div class='more-bets'>
					<div class='more-line'>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s00')}]" @click="betClick(match, 'crs', 's01s00')">
							<div class='more-bet-name'>1:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s00')}]" @click="betClick(match, 'crs', 's02s00')">
							<div class='more-bet-name'>2:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s01')}]" @click="betClick(match, 'crs', 's02s01')">
							<div class='more-bet-name'>2:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s03s00')}]" @click="betClick(match, 'crs', 's03s00')">
							<div class='more-bet-name'>3:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s03s01')}]" @click="betClick(match, 'crs', 's03s01')">
							<div class='more-bet-name'>3:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s03s02')}]" @click="betClick(match, 'crs', 's03s02')">
							<div class='more-bet-name'>3:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s04s00')}]" @click="betClick(match, 'crs', 's04s00')">
							<div class='more-bet-name'>4:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s04s01')}]" @click="betClick(match, 'crs', 's04s01')">
							<div class='more-bet-name'>4:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s04s02')}]" @click="betClick(match, 'crs', 's04s02')">
							<div class='more-bet-name'>4:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s05s00')}]" @click="betClick(match, 'crs', 's05s00')">
							<div class='more-bet-name'>5:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s05s01')}]" @click="betClick(match, 'crs', 's05s01')">
							<div class='more-bet-name'>5:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s05s02')}]" @click="betClick(match, 'crs', 's05s02')">
							<div class='more-bet-name'>5:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s1sh')}]" @click="betClick(match, 'crs', 's1sh')">
							<div class='more-bet-name'>胜其它</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
					</div>
					
					<div class='more-line'>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s00')}]" @click="betClick(match, 'crs', 's00s00')">
							<div class='more-bet-name'>0:0</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s01')}]" @click="betClick(match, 'crs', 's01s01')">
							<div class='more-bet-name'>1:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s02')}]" @click="betClick(match, 'crs', 's02s02')">
							<div class='more-bet-name'>2:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s03s03')}]" @click="betClick(match, 'crs', 's03s03')">
							<div class='more-bet-name'>3:3</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s1sd')}]" @click="betClick(match, 'crs', 's1sd')">
							<div class='more-bet-name'>平其它</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
					</div>
					<div class='more-line'>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s01')}]" @click="betClick(match, 'crs', 's00s01')">
							<div class='more-bet-name'>0:1</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s02')}]" @click="betClick(match, 'crs', 's00s02')">
							<div class='more-bet-name'>0:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s02')}]" @click="betClick(match, 'crs', 's01s02')">
							<div class='more-bet-name'>1:2</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s03')}]" @click="betClick(match, 'crs', 's00s03')">
							<div class='more-bet-name'>0:3</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s03')}]" @click="betClick(match, 'crs', 's01s03')">
							<div class='more-bet-name'>1:3</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s03')}]" @click="betClick(match, 'crs', 's02s03')">
							<div class='more-bet-name'>2:3</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s04')}]" @click="betClick(match, 'crs', 's00s04')">
							<div class='more-bet-name'>0:4</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s04')}]" @click="betClick(match, 'crs', 's01s04')">
							<div class='more-bet-name'>1:4</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s04')}]" @click="betClick(match, 'crs', 's02s04')">
							<div class='more-bet-name'>2:4</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s00s05')}]" @click="betClick(match, 'crs', 's00s05')">
							<div class='more-bet-name'>0:5</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s01s05')}]" @click="betClick(match, 'crs', 's01s05')">
							<div class='more-bet-name'>1:5</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s02s05')}]" @click="betClick(match, 'crs', 's02s05')">
							<div class='more-bet-name'>2:5</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
						<div :class="['more-bet', {'active':selectedArr.includes(match.match_id + '@crs@s1sa')}]" @click="betClick(match, 'crs', 's1sa')">
							<div class='more-bet-name'>负其它</div>
							<div class='more-bet-odds'>2.6</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['match', 'totalMatches', 'reset'],
		data(){
			return {
				matchList:[],
				selectedArr: []
			}
		},
		watch:{
			reset(_new, _old){
				this.selectedArr = [];
			}
		},
		mounted(){
		},
		beforeUnmount() {
		},
		methods:{
			getResultName(_pool, _bet){
				if(_pool == 'had'){
					switch(_bet){
						case '3': return '胜'; case '1': return '平'; case '0': return '负';
						default: return '未知';
					}
				}
				if(_pool == 'hhad'){
					switch(_bet){
						case '3': return '让胜'; case '1': return '让平'; case '0': return '让负';
						default: return '未知';
					}
				}
				if(_pool == 'hafu'){
					switch(_bet){
						case '33': return '胜胜'; case '31': return '胜平'; case '30': return '胜负';
						case '13': return '平胜'; case '11': return '平平'; case '10': return '平负';
						case '03': return '负胜'; case '01': return '负平'; case '00': return '负负';
						default: return '未知';
					}
				}
			},
			betClick(_match, _pool, _bet){
				if(!_match[_pool][_bet]){
					return;
				}
				const _key = `${_match.match_id}@${_pool}@${_bet}`
				const index = this.selectedArr.indexOf(_key);
				if(index === -1){
					const hasMatches = this.selectedArr.filter(key => key.startsWith(_match.match_id + '@')).length;
					if(this.totalMatches > 7 && hasMatches == 0){
						this.$message({
							 message: '最多选择8场比赛进行过关',
							 type: 'warning',
						});
						return;
					}
					this.selectedArr.push(_key)
				} else {
					this.selectedArr.splice(index, 1)
				}
				this.$emit('toggle', _match, _pool, _bet);
			},
			moreFunc(_match){
				if(_match.isMore){
					_match.isMore = false;
				}else{
					this.$set(_match, 'isMore', true);
				}
			}
		}
	}
</script>

<style>
</style>